import React from 'react';
import { Carousel } from 'antd';
import { Box, Button, Container, Divider, Grid, Link, Stack, Typography } from '@mui/material';
import Iconify from '../Iconify';
import logo from '../../assets/logo/logo2.png';
import androidBadge from '../../assets/badges/google-play-badge.png';
import iosBadge from '../../assets/badges/ios.svg';
import LucideIcon from '../LucideIcon';
// import {ReactComponent as iosBadge} from '../../assets/badges/ios.svg';

function AppFooter() {
  return (
    <div className="footer ">
      <Container maxWidth="xl">
        <Stack spacing={5}>
          {/** first line */}
          <Stack spacing={2} direction={{xs:'column', md:'row'}}>
            <Stack width={'100%'} spacing={2}>
              <Link href="/fr/" underline="none">
                <img src={logo} alt="logo" style={{ width: '50px', marginBottom: '16px' }} />
              </Link>
              <Typography color="text.secondary" fontSize={18}>
                La solution de billetterie nouvelle génération pour tous vos événements en Afrique.
              </Typography>
              <Stack spacing={1} direction={'row'}>
                <LucideIcon name='Mail' />
                <Typography color="text.secondary" fontSize={18}>
                  contact@choptonticket.com
                </Typography>
              </Stack>
              <Stack spacing={1} direction={'row'}>
                <LucideIcon name='Phone' />
                <Link
                  href="http://api.whatsapp.com/send?phone=2250709219343"
                  underline="hover"
                  target="_blank" // pour ouvrir le lien dans un nouvel onglet
                  rel="noopener noreferrer" color="inherit" // pour des raisons de sécurité
                >
                  <Typography color="text.secondary" fontSize={18}>
                    +225 0782096458
                  </Typography>
                </Link>

              </Stack>
            </Stack>
            <Stack width={'100%'} spacing={2} alignItems={{xs: 'start', md:'center'}}>
              <Typography color="text.primary" fontWeight={550} fontSize={18}>
                Produit
              </Typography>
              <Link
                href="#work"
                underline="hover"
                color="inherit" // pour des raisons de sécurité
              >
                <Typography color="text.secondary" fontSize={18}>
                  Comment ça marche
                </Typography>
              </Link>
              <Link
                href="#work"
                underline="hover"
                color="inherit" // pour des raisons de sécurité
              ><Typography color="text.secondary" fontSize={18}>
                  Fontionnalités
                </Typography></Link>

              <Link
                href="#pricing"
                underline="hover"
                color="inherit" // pour des raisons de sécurité
              ><Typography color="text.secondary" fontSize={18}>
                  Tarifs
                </Typography></Link>

              <Link
                href="#faq"
                underline="hover"
                color="inherit" // pour des raisons de sécurité
              ><Typography color="text.secondary" fontSize={18}>
                  FAQ
                </Typography></Link>


            </Stack>
            <Stack spacing={2} width={'100%'} alignItems={{xs: 'start', md:'center'}}>
              <Typography color="text.primary" fontWeight={550} fontSize={18}>
                Légal
              </Typography>
              <Link href="https://support.choptonticket.com/fr/categories/legacy/articles/cgu" color="inherit" underline="hover"><Typography color="text.secondary" fontSize={18}>
                Conditions d'utilisation
              </Typography></Link>
              <Link href="https://support.choptonticket.com/fr/categories/legacy/articles/cgp" color="inherit" underline="hover"><Typography color="text.secondary" fontSize={18}>
                Politique de confidentialité
              </Typography></Link>
              <Typography color="text.secondary" fontSize={18}>
                Cookies
              </Typography>
            </Stack>
          </Stack>
          {/** second line */}
          <Divider />
          <Stack spacing={2} direction={{xs:'column', md:'row'}} justifyContent={'space-between'} alignItems={'center'}>
            <Typography color="text.secondary" fontSize={18} textAlign={{xs:'center', md:'start'}}>
              © {new Date().getFullYear()} Choptonticket. Tous droits réservés.
            </Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Link href="#" color="inherit">
                <Iconify icon="akar-icons:facebook-fill" width={24} height={24} />
              </Link>
              <Link href="#" color="inherit">
                <Iconify icon="akar-icons:instagram-fill" width={24} height={24} />
              </Link>
              <Link href="#" color="inherit">
                <Iconify icon="akar-icons:twitter-fill" width={24} height={24} />
              </Link>
              <Link href="#" color="inherit">
                <Iconify icon="akar-icons:linkedin-fill" width={24} height={24} />
              </Link>
            </Box>
          </Stack>
        </Stack>
      </Container>
    </div>
  );
}

export default AppFooter;
